import { render, staticRenderFns } from "./FirmaTanimla.vue?vue&type=template&id=a241e6c2&"
import script from "./FirmaTanimla.vue?vue&type=script&lang=js&"
export * from "./FirmaTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports